export { default as VaultV2ChartTotalDepositError } from './VaultV2ChartTotalDepositError'
export { default as VaultV2ChartTotalDepositLoading } from './VaultV2ChartTotalDepositLoading'
